<template>
    <div class="loader">
        <img src="/assets/loader-2.gif" width="100"/>
    </div>
    <!-- This loader loads on whole page -->
</template>
<script>
export default{
    name:'app-loader'
}
</script>
<style>
.loader{
    display: flex;flex-direction: column;align-items: center;font-size: 16px;width:100px;font-weight: 600;
}
</style>